<template>
  <v-footer :class="this.data.bkgd">
    <v-layout row justify-end class="ml-2 mr-1">
      <div :class="ui.textDescription">
        Software Release {{this.appRevCurrent}}
      </div>
    </v-layout>
  </v-footer>
</template>

<script>
/* eslint-disable */
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";
import appRevisions from "@/data/globals/mixins/appRevisions.js";
import moment from "moment";
export default {
  mixins: [apptheme, publicGlobals, appRevisions],
  data() {
    return {
      year: "2024",
      currentPagePath: "/legal"
    };
  },
  props: {
    data: {
      type: Object
    }
  },
  beforeMount() {
    this.year = moment().format("YYYY");
  }
};
</script>
